const APIHeader = {
    // apiKey: "dajsioje$3ioh30",
    contentType: "application/json"
}

export default APIHeader;